<section class="centered">
  <img class="img-logo" src="../../../../assets/images/logo_login.png" />
  <h1>Ups!! Unauthorized (404)</h1>
  <h3>No se encuentra autorizad@ para realizar la petición al servicio. Lo sentimos!</h3>
</section>
